/**
 * Builds the "card chip" drag preview used when a customer-row drag is started.
 * Used by both contacts-table and accounts-table to swap out the browser's
 * default whole-row drag image. Pure DOM; no Angular deps so it stays callable
 * from `dragstart` handlers without service injection.
 */
export function buildRowDragGhost(label: string, subtitleText = ''): HTMLDivElement {
  const ghost = document.createElement('div');
  ghost.className = 'omni-row-drag-ghost';
  const accent = document.createElement('span');
  accent.className = 'omni-row-drag-ghost__accent';
  const body = document.createElement('div');
  body.className = 'omni-row-drag-ghost__body';
  const title = document.createElement('span');
  title.className = 'omni-row-drag-ghost__title';
  title.textContent = label;
  const subtitleEl = document.createElement('span');
  subtitleEl.className = 'omni-row-drag-ghost__subtitle';
  subtitleEl.textContent = subtitleText;
  body.appendChild(title);
  body.appendChild(subtitleEl);
  ghost.appendChild(accent);
  ghost.appendChild(body);
  return ghost;
}
